import { FormEvent, useRef, useState } from 'react';
import { TbMail, TbCode, TbLockPassword } from 'react-icons/tb';
import useCountdown from '../../hooks/use-countdown';
import { showError, showSuccess } from '../../core/utils';
import { changeForgotPassword, sendForgotCode, validateEmail, verifyForgotCode } from '../../core/auth';

export default function ForgotPasswordForm({ apiEndpoint }: { apiEndpoint: string }) {
  const [requesting, setRequesting] = useState(false);
  const { countTime, setCountdown } = useCountdown(90);
  const [step, setStep] = useState(1);
  const emailRef = useRef('');

  return (
    <form
      className={"auth_form"}
      onSubmit={async (event: FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        const formData = new FormData(event.currentTarget);
        const email = formData.get('email') as string;
        const code = formData.get('code') as string;
        const password = formData.get('password') as string;
        const confirmPassword = formData.get('confirm-password') as string;

        if (step === 1) {
          try {
            setRequesting(true);
            await verifyForgotCode({ email, code }, apiEndpoint);
            setStep(2);
          } catch (e) {
            showError(e);
          } finally {
            setRequesting(false);
          }
          return;
        }
        if (password !== confirmPassword) {
          showError('Mật khẩu xác nhận chưa khớp');
          return;
        }
        try {
          setRequesting(true);
          await changeForgotPassword({ email, code, password }, apiEndpoint);
          showSuccess('Mật khẩu của bạn đã được đổi thành công');
          window.JoyGameSDKInstance.openAuthModal(false);
        } catch (e) {
          showError(e);
        } finally {
          setRequesting(false);
        }

      }}
    >
      <div className="form_item">
        <TbMail />
        <input
          onChange={(e) => { emailRef.current = e.target.value; }}
          type="email"
          id="email"
          name="email"
          placeholder="Địa chỉ E-mail"
          required
        />
        <button
          className={"input_btn"}
          type="button"
          disabled={countTime < 90}
          onClick={async () => {
            if (!emailRef.current) {
              showError('Hãy nhập địa chỉ e-mail của bạn');
              return;
            }
            if (!validateEmail(emailRef.current)) {
              showError('Định dạng email chưa đúng');
              return;
            }
            try {
              setRequesting(true);
              await sendForgotCode({ email: emailRef.current }, apiEndpoint);
              showSuccess('Một mã xác thực đã được gửi đến hộp thư e-mail của bạn, xin hãy kiểm tra.');
              setCountdown(90);
            } catch (e) {
              showError(e);
            } finally {
              setRequesting(false);
            }
          }}
        >
          Gửi mã
          {' '}
          {countTime < 90 && `(${countTime}s)`}
        </button>
      </div>
      <div className="form_item">
        <TbCode />
        <input
          name="code"
          placeholder="Mã xác thực"
          required
        />
      </div>
      {step === 2 && (
        <>
          <div className="form_item">
            <TbLockPassword /><input type="password" id="password" name="password" placeholder="Mật khẩu" required />
          </div>
          <div className="form_item">
            <TbLockPassword /><input type="password" id="confirm-password" name="confirm-password" placeholder="Xác nhận mật khẩu" required />
          </div>
        </>
      )}
      <button
        type="submit"
        className={"primary_btn"}
        disabled={requesting}
      >
        Xác nhận
      </button>
    </form>
  );
}
